import { useEffect, useState } from "react";

type MotionPref = "auto" | "full" | "reduced";

const KEY = "ci.motionPref";

const readSystem = () =>
  typeof window !== "undefined" &&
  window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

export const useMotionPreference = () => {
  const [pref, setPref] = useState<MotionPref>(() => {
    if (typeof window === "undefined") return "auto";
    return (localStorage.getItem(KEY) as MotionPref) || "auto";
  });
  const [systemReduced, setSystemReduced] = useState<boolean>(readSystem);

  useEffect(() => {
    const mql = window.matchMedia("(prefers-reduced-motion: reduce)");
    const handler = () => setSystemReduced(mql.matches);
    mql.addEventListener?.("change", handler);
    return () => mql.removeEventListener?.("change", handler);
  }, []);

  const update = (next: MotionPref) => {
    setPref(next);
    if (next === "auto") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, next);
  };

  const reduced =
    pref === "reduced" || (pref === "auto" && systemReduced);

  return { pref, setPref: update, reduced, systemReduced };
};
